<script setup>
import { computed, watch, getCurrentInstance } from 'vue';
import { useAsyncState } from '@vueuse/core';

const props = defineProps({
    tableName: String,
    id: Number
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State & Async ---

// useAsyncState handles the async data fetching previously done by asyncComputed
const { state: item, execute: fetchItem } = useAsyncState(
    () => store.dispatch('itemData/get', {
        tableName: props.tableName,
        id: props.id
    }),
    null,
    { immediate: true }
);

// --- Computed ---

const componentId = computed(() => {
    return store.state.components.componentIds[props.tableName];
});

const nameField = computed(() => {
    // Looks up which field acts as the "Title/Name" for this specific table
    return store.getters['components/nameField'](componentId.value);
});

const displayTitle = computed(() => {
    if (item.value && nameField.value) {
        return item.value[nameField.value];
    }
    return '...'; // Placeholder while loading
});

// --- Watchers ---

// If the ID or Table changes, we need to re-run the fetch
watch(
    () => [props.id, props.tableName],
    () => fetchItem()
);
</script>

<template>
    <span>{{ displayTitle }}</span>
</template>

<style scoped>
</style>